import { create } from "zustand";

const defaultNewTeam = {
    teamName: "",
    countries: [],
    therapeuticAreaIds: [],
    minimumContractReviewers: 0,
    minimumFinancialApprovers: 0,
    users: [],
    bpfProcessingEmail: false,
};

const defaultSteps = [
    {
        id: "create-team",
        title: "Creating a new contract team",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
    {
        id: "team-overview",
        title: "Creating a new contract team",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
    {
        id: "edit-team",
        title: "Edit contract team",
        description:
            "Lorem 2 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
];

interface CreateTeamState {
    newTeam: typeof defaultNewTeam;
    setNewTeam: (team: any) => void;

    steps: typeof defaultSteps;
    setSteps: (steps: any) => void;

    resetTeamData: () => void;
}

export const useCreateTeamStore = create<CreateTeamState>(set => ({
    newTeam: defaultNewTeam,
    setNewTeam: newTeam => set({ newTeam }),

    steps: defaultSteps,
    setSteps: steps => set({ steps }),

    resetTeamData: () =>
        set({
            newTeam: defaultNewTeam,
            steps: defaultSteps,
        }),
}));
